import * as React from 'react';

import { RowTitle } from 'common/components';
import useExpandedSections from 'components/common/EntityDataTable/hooks/useExpandedSections';
import StepActionsButton from 'security-app/components/SecurityEvents/EventProcedures/plugin/StepList/StepActionsButton';
import type { ColumnRenderers } from 'components/common/EntityDataTable';
import type { EntityBase } from 'components/common/EntityDataTable/types';
import type { EventProcedureStepAPIType } from 'security-app/hooks/api/eventProceduresAPI.types';

const TitleCell = ({ step }: { step: EventProcedureStepAPIType }) => {
  const { toggleSection } = useExpandedSections();
  const toggleExtraSection = () => toggleSection(step.id, 'restFieldsExpandedSection');

  return <RowTitle onClick={toggleExtraSection}>{step?.title || 'No title set'}</RowTitle>;
};

// eslint-disable-next-line import/prefer-default-export
export const columnRenderers: ColumnRenderers<EntityBase & EventProcedureStepAPIType> = {
  attributes: {
    title: {
      renderCell: (_: string, step: EventProcedureStepAPIType) => <TitleCell step={step} />,
    },
    type: {
      renderCell: (_: string, step: EventProcedureStepAPIType) => <StepActionsButton step={step} />,
      staticWidth: 120,
    },
  },
};
